









































import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import BusinessUpdateGeneral from "./Update/BusinessUpdateGeneral.vue";
import BusinessUpdateContactList from "./Update/BusinessUpdateContactList.vue";
import BusinessUpdateAddressList from "./Update/BusinessUpdateAddressList.vue";
import BusinessUpdateCreditCheck from "./Update/BusinessUpdateCreditCheck.vue";
import BusinessUpdateUserList from "./Update/BusinessUpdateUserList.vue";
import BusinessUpdateServiceOrder from "./Update/BusinessUpdateServiceOrder.vue";
import BusinessUpdateBookingList from "./Update/BusinessUpdateBookingList.vue";
import BusinessUpdateReferralBusiness from "./Update/BusinessUpdateReferralBusiness.vue";

@Component({
  components: {
    BusinessUpdateGeneral,
    BusinessUpdateContactList,
    BusinessUpdateAddressList,
    BusinessUpdateCreditCheck,
    BusinessUpdateUserList,
    BusinessUpdateServiceOrder,
    BusinessUpdateBookingList,
    BusinessUpdateReferralBusiness
  },
  computed: {
    ...mapState("Auth", {
      activeBusiness: "activeBusiness"
    }),
    ...mapState("Country", {
      countries: "countries"
    })
  }
})
export default class BusinessUpdate extends Vue {
  isMounted = false;

  activeBusiness!: Model;
  countries!: [];

  sidebarItems = [
    {
      title: "General"
    },
    {
      title: "Contacts"
    },
    {
      title: "Addresses"
    },
    {
      title: "Credit Check"
    },
    {
      title: "Team"
    },
    {
      title: "Order & Credit Balance"
    },
    {
      title: "Booking History"
    },
    {
      title: "Referral"
    },
    {
      title: "Tags"
    }
  ];

  sidebarIndex = 0;

  async created() {
    if (this.countries.length === 0) {
      await this.$store.dispatch("Country/fetchList");
    }
    this.$store
      .dispatch("Business/fetch", {
        businessOid: this.$route.params.businessOid,
        config: {
          params: {
            expand: [
              "business_contacts",
              "business_addresses",
              "billing_address",
              "billing_contact",
              "postal_address",
              "primary_contact",
              "director_contact"
            ]
          }
        }
      })
      .then(() => {
        this.isMounted = true;
      });
  }
}
